import * as React from 'react';
import Link from '@mui/material/Link';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { RootState } from 'store/store';
import { useDispatch, useSelector } from 'react-redux';
import { AuthContext } from 'index';
import CloseSurveyModal from 'modals/CloseSurveyModal';
import { setOpenedCloseSurveyModal, setTemporaryLinkText } from 'store/questionnaireSlice';

type LinkButtonProps = {
    underline?: 'none' | 'hover' | 'always';
    link: string;
    text: string;
    linkCustomStyle?: any;
}

const LinkComponent = ({ underline, link, text, linkCustomStyle }: LinkButtonProps) => {
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const isBookedNow = useSelector((state: RootState) => state.global.isBookedNow);
    const participantViewState = useSelector((state: RootState) => state.user.participantViewState);
    const auth = React.useContext(AuthContext);
    const [isDisabled, _] = useState<boolean>(false);
    
    const onLogout = React.useCallback(() => {
        localStorage.removeItem('id_token');
        if (process.env.NODE_ENV !== 'development'){
            localStorage.setItem('logoutCheck', Date.now().toString());
        }
        auth.logout({ redirectUri: process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://planetdiet.dk/' });
    }, [auth]);

    const linkTo = (linkText: string) => {
        dispatch(setTemporaryLinkText(linkText));
        if(location.pathname === '/questionnaire-json') {
            dispatch(setOpenedCloseSurveyModal(true));
        } else {
            if (isBookedNow) {
                onLogout();
            } else {
                if (participantViewState !== 'Access to DashBoard 1') {
                    return null;
                }
                navigate(linkText);
            }
        }
    };

    return(
        <>
            <Link
                className={linkCustomStyle ? linkCustomStyle : null}
                component="button"
                underline={underline || 'none'}
                variant="body2"
                onClick={() => linkTo(link)}
                disabled={isDisabled}
            >
                {text}
            </Link>
            <CloseSurveyModal />
        </>
    );
};

export default LinkComponent;
